import { render, staticRenderFns } from "./ParentDashboard.vue?vue&type=template&id=5e6a7bb8&scoped=true&"
import script from "./ParentDashboard.vue?vue&type=script&lang=js&"
export * from "./ParentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ParentDashboard.vue?vue&type=style&index=0&id=5e6a7bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6a7bb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
